export const GET_PAYMENT_GATEWAYS = "GET_PAYMENT_GATEWAYS";
